module.exports = __webpack_public_path__ + "static/pie6-f5e0a030b941680b6f1ae87c47a6963e.png";